import React, { useEffect, useState } from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { useTranslation } from 'react-i18next';
import customerActions from '../../Actions/customerActions';
import CustomerEmailsList from '../../Components/Customer/CustomerEmailsList';
import CustomerEmailHistoryModal from '../../Components/Customer/CustomerEmailHistoryModal';
import { DefaultCard } from '../../Components/Card/Card';
import useModal from '../../Hooks/useModal';
import modals from '../../Constants/modals';

function CustomerEmailsContainer({ customerActions, customer, customerHubSpotEmails }) {
    const { t } = useTranslation();
    const customerNumber = customer?.vbCustomer?.customerNumber;
    const { openModal, closeModal, isModalOpen } = useModal();
    const [selectedEmail, setSelectedEmail] = useState(null);

    useEffect(() => {
        if (customerNumber) {
            customerActions.getHubSpotEmailsForCustomer(customerNumber);
        }
        return () => {
            customerActions.clearHubSpotEmailsForCustomer();
        };
    }, [customerNumber]);

    const onHistoryClick = (item) => {
        setSelectedEmail(item);
        openModal(modals.CustomerEmailHistory);
    };

    const onHistoryClose = () => {
        setSelectedEmail(null);
        closeModal();
    };

    const isLoading = !customerHubSpotEmails;
    const isEmpty = !isLoading && customerHubSpotEmails.length === 0;

    return (
        <DefaultCard title={t('customeremails.title')} isLoading={isLoading}>
            {!isLoading && (
                <>
                    <div className="alert alert-info" role="note">
                        {t('customeremails.userScopeNote')}
                    </div>
                    {isEmpty ? (
                        <p><i>{t('customeremails.empty')}</i></p>
                    ) : (
                        <>
                            <CustomerEmailsList
                                emails={customerHubSpotEmails}
                                onHistoryClick={onHistoryClick}
                            />
                            {isModalOpen(modals.CustomerEmailHistory) && selectedEmail && (
                                <CustomerEmailHistoryModal email={selectedEmail} onClose={onHistoryClose} />
                            )}
                        </>
                    )}
                </>
            )}
        </DefaultCard>
    );
}

function mapStateToProps(state) {
    return {
        customerHubSpotEmails: state.CustomerReducer.customerHubSpotEmails,
        customer: state.CustomerReducer.customer
    };
}

function mapDispatchToProps(dispatch) {
    return {
        customerActions: bindActionCreators(customerActions, dispatch)
    };
}

export default connect(mapStateToProps, mapDispatchToProps)(CustomerEmailsContainer);
